export default __webpack_public_path__ + "static/csiModalBg-348dcadd1937c01b2d609e3314b16f35.png";